<template>
<div>
    <section class="top-nav">
    <div>
          <router-link :to="{ path: '/' }" class="link"><img src="../assets/img/logo-pferdeverstand-2.png" class="logo" alt="weiterkommen mit Pferdeverstand.at"/>
        <h1 class="sr-only">Pferdeverstand - Training und Gesundheit f&uuml;r Reiter und Pferd</h1></router-link>
    </div>
    <input id="menu-toggle" type="checkbox" />
    <label class='menu-button-container' for="menu-toggle">
    <div class='menu-button'></div>
  </label>
    <ul class="menu">
        <li>
          <router-link :to="{ path: '/about' }" class="link">&Uuml;ber mich</router-link>
        </li>
        <li >
          <router-link :to="{ path: '/leistungen' }" class="link">Leistungen</router-link>
          <ul class="hidden">
            <li>
              <router-link :to="{ path: '/#pferdetraining' }" class="link">Pferdetraining</router-link>
            </li>
            <li>
              <router-link :to="{ path: '/#reitunterricht' }" class="link">Reitunterricht</router-link>
            </li>
            <li>
              <router-link :to="{ path: '/#analyse' }" class="link">Analyse</router-link>
            </li>
            <li>
              <router-link :to="{ path: '/#fortbildung' }" class="link">Fortbildung</router-link>
            </li>
          </ul>
        </li>
         <li>
          <!-- <router-link :to="{ path: '/methoden' }" class="link">Methoden</router-link> -->
          <router-link :to="{ path: '/neuro' }" class="link">Neuro-Athletik</router-link>

          <ul class="hidden">
            <li>
              <router-link :to="{ path: '/#pferdegesundheit' }" class="link">Pferdegesundheit</router-link>
            </li>
            <li>
              <router-link :to="{ path: '/#trainingsgrundlagen' }" class="link">Trainingsgrundlagen</router-link>
            </li>
            <li>
              <router-link :to="{ path: '/#centeredriding' }" class="link">Centered Riding</router-link>
            </li>
            <li>
              <router-link :to="{ path: '/#franklinmethode' }" class="link">Franklin-Methode</router-link>
            </li>
            <li>
              <router-link :to="{ path: '/neuro' }" class="link">Neuro-Rider</router-link>
            </li>
          </ul>
        </li>

        <li>
            <router-link :to="{ path: '/termine' }" class="link">Termine</router-link>
        </li>
        

        <li>
            <router-link :to="{ path: '/kontakt' }" class="link">Kontakt</router-link>
        </li>
    </ul>

          <!-- <div class="newsletter-box">

              <h3>Bleib in Verbindung</h3>
                <p>Damit du nichts mehr verpasst, melde dich zum 
                  <router-link :to="{ path: '/newsletter' }" class="link"> <img src="../assets/img/news-icon.svg" width="30px"> Newsletter</router-link>
                  an.</p>
                  <p>Außerdem gibts regelmäßige Infos auf <img src="../assets/img/facebook.svg" width="30px">
                          <a href="https://www.facebook.com/pferdeverstand.at">Facebook</a> und <img src="../assets/img/insta.svg" width="30px"> <a href="https://www.instagram.com/pferdeverstand.at/">Instagram</a>.</p>
  </div> -->

    </section>

  </div>

</template>

<script>
import navigation from '../shared/navigationHelper';

export default {
  name: "Navigation",
  created() { 
      this.initNavigation = navigation.init;
    },
  mounted () {
      this.initNavigation();
  },
  data() {
    return {
      topNav: [
        {
          id: 0,
          text: "Home",
          textMobile: "Home",
          page: "/",
        },
        {
          id: 1,
          text: "Neuro",
          textMobile: "Neuro",
          page: "/neuro",
        },
        {
          id: 2,
          text: "Newsletter",
          textMobile: "Newsletter",
          page: "/newsletter",
        } 
      ]
      
    };
  },
};
</script>
<style>
.spacing {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue